<div class="memic-panel panel">
  <div class="panel-heading">
    <h3 class="panel-title">Webinars On Demand</h3>
  </div>
  <div class="panel-body memic-list">
    <div *ngIf="!webinars">
      <em>Loading Webinars...</em>
    </div>
    <ul class="memic-list memic-list--details memic-list--brdless list-group m-a-0" *ngFor="let webinar of webinars; index as i;">
      <li class="memic-list__body list-group-item p-x-0">
        <div class="memic-list__body-left">
          <img class="memic-icn memic-icn-png" [src]="'../assets/icons/play.png'">
        </div>
        <div class="memic-list__body-right">
          <header class="memic-list__header">
            <h2 class="memic-list__title"><a (click)="openModal(webinarModal, webinar)" href="javascript:void(null)">{{webinar.title}}</a></h2>
          </header>
        </div>
      </li>
    </ul>
    <div *ngIf="webinars && webinars.length > 0">
      <div class="card-footer memic-card-footer text-muted">
        <a href="javascript:void(null)" [ngClass]="{'disabled': tap <= 0}" class="btn memic-btn-link memic-btn-link--primary pull-left" (click)="prevPage()">
          <i class="fas fa-chevron-left" aria-hidden="true"></i>
          Previous
        </a>
        <a href="javascript:void(null)" [ngClass]="{'disabled': tap >= totalWebinarsBatch - 1}" class="btn memic-btn-link memic-btn-link--primary pull-right" (click)="nextPage()">
          Next
          <i class="fas fa-chevron-right" aria-hidden="true"></i>
        </a>
      </div>
    </div>
    <div *ngIf="webinars && webinars.length == 0">
      <em>Checkback Soon For Webinars On Demand</em>
    </div>
  </div>
</div>

<!-- Webinar Modal Dialog -->
<ng-template #webinarModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="editProfileLabel">Webinars On Demand</h4>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row m-b-3">
      <div class="col-md-12">
        <h3>{{selectedWebinar.title}}</h3>        
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <iframe [src]="selectedWebinarUrl" width="750" height="425" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
      <div class="col-md-4">
        <p class="memic-webinars--description">{{selectedWebinar.subheading}}</p>
        <div *ngIf="selectedWebinar.relatedDocument!.length > 0" class="memic-panel panel">
          <div class="panel-heading">
            <h3 class="panel-title">Related Documents</h3>
          </div>
          <div class="panel-body">
            <ul class="memic-list memic-list--details memic-list--brdless list-group m-a-0" *ngFor="let document of selectedWebinar.relatedDocument;">
              <li class="memic-list__body list-group-item p-x-0">
                <div class="memic-list__body-left">
                  <img #fileIcon class="memic-icn memic-icn-png" [src]="'../assets/icons/' + document.blobExtension.replace('.', '') +'.png'">
                </div>
                <div class="memic-list__body-right">
                  <header class="memic-list__header">
                    <h2 class="memic-list__title"><a href="javascript:void(null)" (click)="downloadFile(document, fileIcon)">{{document.title}}</a></h2>
                  </header>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
